import TopNavBar from '../../components/reusables/topNavBar';
import ReservationsTable from './reservationsTable';

function Reservations() {
    return (
        <div className='h-full flex flex-col'>
            <TopNavBar
                title="Reservas"
                subtitle="Gerencie as reservas do dia por turno."
            />
            <div className='flex-1 overflow-hidden font-poppins'>
                <ReservationsTable mode="admin" />
            </div>
        </div>
    );
}

export default Reservations;
